import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ThreadForm from "../../components/forum/ThreadForm";
import ThreadListItem from "../../components/forum/ThreadListItem";

import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { PageTitleWithUnderline } from "../../components/common/PageTitleWithUnderline";
import { SubPageTitleWithUnderline } from "../../components/common/SubPageTitleWithUnderline";
import { PageWrapper } from "../../components/common/PageWrapper";
import { Button, Card, CardContent } from "@mui/material";
import MessageIcon from "@mui/icons-material/Message";
import { ThreadType, TopicType } from "../../utils/types";
import TopicForm from "../../components/forum/TopicForm";

const ForumPage = () => {
  const navigate = useNavigate();
  // initalize component state
  const [threads, setThreads] = useState<ThreadType[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [topThreads, setTopThreads] = useState<ThreadType[]>([]);
  const [topics, setTopics] = useState<TopicType[]>([]);

  const getMoreThreads = async () => {
    const response = await fetch(`/api/threads/?page=${page}`);
    const data = await response.json();

    return data.results;
  };
  const fetchData = async () => {
    const moreThreads = await getMoreThreads();
    setThreads([...threads, ...moreThreads]);
    if (moreThreads.length === 0 || moreThreads.length < 4) {
      setHasMore(false);
    }
    setPage(page + 1);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const getThreads = async () => {
      const response = await fetch(`/api/threads/?page=1`);
      const data = await response.json();
      setThreads(data.results);
      if (data.next === null) {
        setHasMore(false);
      }
    };
    const getTopThreads = async () => {
      const response = await fetch(`/api/topThreads/`);
      const data = await response.json();
      setTopThreads(data);
    };
    getTopThreads();
    getThreads();
  }, []);

  useEffect(() => {
    const fetchTopics = async () => {
      const response = await fetch("/api/topics/");
      const data = await response.json();
      setTopics(data);
    };
    fetchTopics();
  }, []);

  // style the paper component
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(),
    textAlign: "left",
    color: theme.palette.text.secondary,
  }));

  return (
    <PageWrapper>
      <Grid container spacing={3}>
        <Grid item xs={12} md={9}>
          <div className="NeusteNachrichten">
            <SubPageTitleWithUnderline title="Neueste Nachrichten">
              <ThreadForm />
            </SubPageTitleWithUnderline>

            {threads.map((thread, index) => (
              <ThreadListItem key={index} thread={thread} />
            ))}
            {hasMore && (
              <ListItemButton
                onClick={fetchData}
                style={{ width: "100%", marginTop: "20px" }}
              >
                Mehr Beiträge laden
              </ListItemButton>
            )}
            {!hasMore && (
              <ListItem>
                <p style={{ textAlign: "center", marginTop: 20 }}>
                  <span>Das waren alle.</span>
                </p>
              </ListItem>
            )}
          </div>
        </Grid>

        <Grid item xs={12} md={3}>
          <div className="Themen">
            <SubPageTitleWithUnderline title="Themen">
              <TopicForm />
            </SubPageTitleWithUnderline>
            <List
              sx={{
                width: "100%",
                maxWidth: 360,
                bgcolor: "background.paper",
              }}
              aria-label="topics"
            >
              {topics
                .sort((a, b) => a.label.localeCompare(b.label))
                .map((topic, index) => (
                  <div key={index}>
                    <Link
                      style={{
                        textDecoration: "none",
                        color: "black",
                        textTransform: "capitalize",
                      }}
                      to={`/topic/${topic.id}`}
                    >
                      <ListItem key={index}>
                        <ListItemButton>
                          <ListItemText
                            primary={<Typography>{topic.label}</Typography>}
                          />
                        </ListItemButton>
                      </ListItem>
                    </Link>
                  </div>
                ))}
            </List>
          </div>
        </Grid>

        <Grid
          item
          xs={12}
          md={9}
          sx={{
            display: { md: "block" },
          }}
        >
          <SubPageTitleWithUnderline title="Beliebte Diskussionen" />
          {topThreads.map((thread, index) => (
            <Box sx={{ minWidth: 275, marginTop: 2 }} key={index}>
              <Link
                to={`/threads/${thread.id}`}
                style={{ textDecoration: "none", color: "black" }}
              >
                <Card className="hotTopics" variant="outlined" key={index}>
                  <React.Fragment>
                    <CardContent>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <div>
                          <Typography variant="h6" component="div">
                            {thread?.subject}
                          </Typography>
                          <Typography sx={{ mb: 1.5 }} color="text.secondary">
                            {typeof thread?.creator === "string" ? thread.creator : thread?.creator?.username}
                          </Typography>
                        </div>
                        <Typography
                          variant="body2"
                          color="text.primary"
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <MessageIcon sx={{ marginRight: 1 }} />
                          {thread?.replyCount}
                        </Typography>
                      </div>
                    </CardContent>
                  </React.Fragment>
                </Card>
              </Link>
            </Box>
          ))}
        </Grid>
      </Grid>
    </PageWrapper>
  );
};

export default ForumPage;
